import { TranslationKeys } from 'types/TranslationKeys'

export interface LoadMoreProps {
  news: any[] | null
  newsCount: number
  isLoading: boolean
  handleLoadMore: () => void
  t: (key: TranslationKeys) => string
}

export const useLoadMore = (props: LoadMoreProps) => {
  return {
    ...props,
  }
}
